import Paper from "@mui/material/Paper";
import styled from "styled-components";

export const StyledPlayerSection = styled(Paper)`
  padding: 24px;
`;
